// src/utils/tradeAvailability.js

const OPEN_STATUSES = new Set(["active", "open", "available", "published"]);

const CLOSED_OR_IN_PROGRESS_STATUSES = new Set([
  "locked",
  "risk_review",
  "seller_prep",
  "pickup_scheduled",
  "pickup_in_progress",
  "pickup_inspection_pass",
  "pickup_inspection_fail",
  "hub_inspection_pass",
  "hub_inspection_fail",
  "delivery_scheduled",
  "delivered",
  "completed",
  "cancelled",
  "canceled",
  "held",
  "flagged",
  "review",
]);

function normStatus(s) {
  return String(s || "").trim().toLowerCase();
}

function pickState(trade) {
  // Prefer explicit listing status if set, otherwise fall back to workflow state
  const s = normStatus(trade?.status);
  if (s) return s;
  const wf = normStatus(trade?.workflowState || trade?.workflow_status);
  if (wf) return wf;
  return "";
}

export function isTradeAvailable(trade) {
  if (!trade) return false;

  // Optional hard gate
  if (trade.isAvailable === false) return false;

  const state = pickState(trade);

  // Explicit closed/in-progress pipeline states
  if (CLOSED_OR_IN_PROGRESS_STATUSES.has(state)) return false;

  // Explicit open states
  if (OPEN_STATUSES.has(state)) return true;

  // If nothing is set (common in PublicTrades), treat as open for compatibility
  if (!state) return true;

  // Unknown state => hidden (conservative)
  return false;
}

export function isTradeVisibleToAdmin(trade) {
  if (!trade) return false;
  const s = normStatus(trade?.status);
  if (s === "deleted" || s === "removed") return false;
  return true;
}
